import React, { Component, useState } from 'react';
import { withStyles } from '@material-ui/core';
import LogoMobile from "../../logo2.svg";
import Logo from "../../MenuSifu_New-Logo.png"
import smallLogo from "../../logo_sm.png"
import { TextInput } from "../textInput"
import Profile from "../../containers/profile";
import  PurpleBg  from "./purple_bg.svg";
import ProfileImage from "./account_logo.svg";
const styles = theme => ({
    root: {
        display: "flex",
        flexDirection: "column",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        [theme.breakpoints.down('xs')]: {
            justifyContent: "unset",
            marginTop:20
        },
    },
    signInContainer: {
        height: "max-content",
        // margin: 'calc(50vh - 325px) auto',
        [theme.breakpoints.down('xs')]: {
            width: 280,
            // margin: 'calc(50vh - 245px) auto',
        },
        [theme.breakpoints.up('sm')]: {
            width: 300,
            // margin: 'calc(50vh - 325px) auto',
        }
    },
    domain: { fontSize: "45px", fontWeight: "500" },
    logo: {
        width: 260,
        marginBottom: 74.6,
        [theme.breakpoints.down('xs')]: {
            display: "none"
        }
    },
    logoMobile: {
        width: 160,
        [theme.breakpoints.up('sm')]: {
            display: "none"
        },
    },
    textInputs: {
        marginBottom: 65,
        width: "100%"
    },
    title: {
        fontSize: 24,
        color: "rgba(0,0,0,0.5)",
        marginBottom: 50,
        marginTop: 0
    }
})

export const AuthForm = withStyles(styles)(({title, children, classes}) => {
    return (
        <div className={classes.root}>
            <div className={classes.signInContainer}>
                <div className={classes.domain}>
                    <img className={classes.logo} src={Logo} alt={"MenuSifu"}/>
                    <img className={classes.logoMobile} src={LogoMobile} alt={"MenuSifu"}/>
                </div>
                <h1 className={classes.title}>{title}</h1>
                {children}
            </div>
        </div>
    )
})

const profilestyles = theme => ({
    root: {
        display: "flex",
        flexDirection: "column",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100vh",
        backgroundImage: `url(${PurpleBg})`,
        backgroundRepeat: "no-repeat"
    },
    signInContainer: {
        height: "max-content",
        // margin: 'calc(50vh - 325px) auto',
        [theme.breakpoints.down('xs')]: {
            width: 280,
            // margin: 'calc(50vh - 245px) auto',
        },
        [theme.breakpoints.up('sm')]: {
            width: 300,
            // margin: 'calc(50vh - 325px) auto',
        }
    },
    domain: { 
        opacity: 1, 
        width: "100%",
        justifyContent: "space-between",
        marginTop: 30,
        [theme.breakpoints.down('xs')]: {
            marginTop: 14,
        }
    },
    logo: {
        width: 260,
        marginBottom: 74.6,
        [theme.breakpoints.down('xs')]: {
            display: "none"
        }
    },
    logoMobile: {
        width: 160,
        [theme.breakpoints.up('sm')]: {
            display: "none"
        },
    },
    logoBx: {
        fontSize: "45px", 
        fontWeight: "500", 
        marginLeft: 240,
        display: "flex",
        float: "left",
        [theme.breakpoints.down('md')]: {
            marginLeft: 50,
        },
        [theme.breakpoints.down('xs')]: {
            marginLeft: 14,
        }
    },
    textInputs: {
        marginBottom: 65,
        width: "100%"
    },
    title1: {
        opacity: 0.6,
        color: "#FFF8E6",
        fontSize: "16px",
        fontWeight: 500,
        textAlign: "left",
        margin: 0,
    },
    title2: {
        opacity: 0.8,
        color: "#FFF8E6",
        fontSize: "24px",
        textAlign: "left",
        margin: 0,
        fontWeight: "400",
    },
    titleBx: {

    },
    mobileTitle: {
        [theme.breakpoints.up('sm')]: {
            display: "none"
        }
    },
    headerBackground: {
        height: 230,
        position: "absolute",
        top: 0,
        zIndex: -1
    },
    actionBtns: {
        marginRight: 240,
        color: "white",
        float: "right",
        [theme.breakpoints.down('md')]: {
            marginRight: 50,
        },
        [theme.breakpoints.down('xs')]: {
            display: "none"
        },
    },
    profileLogo: {
        width: 50,
        [theme.breakpoints.down('xs')]: {
            display: "none"
        },
    },
    mobileProfileLogo: {
        float: "right",
        width: 50,
        [theme.breakpoints.up('sm')]: {
            display: "none"
        },
    },
    companyName: {
        fontSize: 30,
        fontWeight: "bold",
        color: "white",
        lineHeight: "50px",
        [theme.breakpoints.down('xs')]: {
            display: "none"
        },
    },
    profileImg: {
        height: "260px",
        width: "260px",
        borderRadius: "25px",
        backgroundColor: "#FFFFFF",
        boxShadow: "0 6px 6px 2px rgba(0,0,0,0.1)",
        marginTop: 18,
        marginBottom: 56,
        [theme.breakpoints.down('xs')]: {
            height: "200px",
            width: "200px",
        },
    },
    mobileProfileImg: {
        height: "260px",
        width: "260px",
        borderRadius: "25px",
        backgroundColor: "#FFFFFF",
        boxShadow: "0 6px 6px 2px rgba(0,0,0,0.1)",
        marginTop: 18,
        marginBottom: 56,
        [theme.breakpoints.up('sm')]: {
            display: "none"
        },
    },
    titles: {
        [theme.breakpoints.down('xs')]: {
            display: "none"
        },
    },
    accountIcon: {
        width: "123%",
        marginLeft: "-11%",
        marginTop: "-11%"
    }
})

export const ProfileForm = withStyles(profilestyles)(({title1, title2, children, classes, profile, auth, fromDomain}) => {
    return (
        <div className={classes.root}>
            <div className={classes.domain}>
                <div className={classes.logoBx}>
                    {/* <img className={classes.logo} src={Logo} alt={"MenuSifu"}/> */}
                    <img className={classes.profileLogo} src={smallLogo} alt={"MenuSifu"}/>
                    <div className={classes.companyName}>
                        MenuSifu
                    </div>
                    <div className={classes.mobileTitle}>
                        <h1 className={classes.title1}>{title1}</h1>
                        <h1 className={classes.title2}>{title2}</h1>
                    </div>
                </div>
                <div className={classes.actionBtns}>
                    <Profile 
                        firstname={profile ? profile.firstname : null} 
                        lastname={profile ? profile.lastname: null}
                        token={auth? auth.token: null}
                        domain={fromDomain}
                    />
                </div>
                <img className={classes.mobileProfileLogo} src={smallLogo} alt={"MenuSifu"} />
            </div>
            <div className={classes.titleBx}>
                <div className={classes.titles}>
                    <h1 className={classes.title1}>{title1}</h1>
                    <h1 className={classes.title2}>{title2}</h1>
                </div>

                <div className={classes.profileImg}>
                    <img src={ProfileImage} className={classes.accountIcon}/>
                </div>
            </div>
            <div className={classes.signInContainer}>
                {children}
            </div>
            {/* <img className={classes.headerBackground} src={PurpleBg} alt={"background"} /> */}
        </div>
    )
})

const authFieldStyle = theme => ({
    input: {
        width: "100%",
        marginBottom: "30px"
    }
})

export const AuthField = withStyles(authFieldStyle)((props) => {
    const {classes} = props;
    return (
        <div className={classes.input}>
            <TextInput {...props}/>
        </div>
    )
})